import { render, staticRenderFns } from "./SelectAlcances.vue?vue&type=template&id=01e92ccc&scoped=true"
import script from "./SelectAlcances.vue?vue&type=script&lang=js"
export * from "./SelectAlcances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e92ccc",
  null
  
)

export default component.exports